<form [formGroup]="formGroup" id="contactForm" data-sb-form-api-token="API_TOKEN">
  <!-- Patient Informations -->
  <div class="row g-2">
    <!-- TCKN -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="tckn" type="text" class="form-control"
          [ngClass]="{ 'bg-secondary': isTcknReadonly }" [readonly]="isTcknReadonly" id="inputPid"
          [placeholder]="'tckn' | translate" maxlength="11" (input)="preventForbiddenCharacters($event, 'number')" />
        <label for="inputPid">*{{ "tckn" | translate }}</label>
        <div *ngIf="isControlInvalid('tckn')" class="text-danger">
          <div *ngIf="formGroup.get('tckn')?.errors?.['required']">
            {{ "tcknIsRequired" | translate }}
          </div>
          <div *ngIf="formGroup.get('tckn')?.errors?.['minlength']">
            {{ "tcknMustBeAtLeast11CharactersLong" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- First Name  -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="name" class="form-control" id="inputFirstName" type="text" placeholder="John Doe"
          (input)="preventForbiddenCharacters($event, 'text')" />
        <label for="inputFirstName">*{{ "firstName" | translate }}</label>
        <div *ngIf="isControlInvalid('name')" class="text-danger">
          <div *ngIf="formGroup.get('name')?.errors?.['required']">
            {{ "firstNameIsRequired" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Last Name -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="lastName" class="form-control" id="inputLastName" type="text" placeholder="John Doe"
          (input)="preventForbiddenCharacters($event, 'text')" />
        <label for="inputLastName">*{{ "lastName" | translate }}</label>
        <div *ngIf="isControlInvalid('lastName')" class="text-danger">
          <div *ngIf="formGroup.get('lastName')?.errors?.['required']">
            {{ "lastNameIsRequired" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Birth of Date -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="birthDate" type="text" class="form-control" id="inputDob"
          (ngModelChange)="onDateInputChange($event)" placeholder="Date of Birth" [max]="maxDate" maxlength="10" />
        <label for="inputDob">*{{ "dateOfBirth" | translate }}</label>
        <div *ngIf="isControlInvalid('birthDate')" class="text-danger">
          <div *ngIf="formGroup.get('birthDate')?.errors?.['dateFormatInvalid']">
            {{ "dateOfBirthIsRequired" | translate }}
          </div>
          <div *ngIf="formGroup.get('birthDate')?.errors?.['dateOfBirthMinLength']">
            {{ "dateOfBirthFormatIsWrong" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Gender -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <select formControlName="gender" class="form-select cursor-pointer" id="inputGender" aria-label="Gender">
          <option [ngValue]="null" disabled>*{{ "gender" | translate }}</option>
          <option *ngFor="let gender of genders" [value]="gender.id">
            {{ gender.name }}
          </option>
        </select>
        <label for="inputGender">{{ "gender" | translate }}</label>
        <div *ngIf="isControlInvalid('gender')" class="text-danger">
          <div *ngIf="formGroup.get('gender')?.errors?.['required']">
            {{ "genderIsRequired" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Height & Weight & BMI -->
    <div class="col-lg-4 col-md-4 col-sm-6">
      <div class="row">
        <!-- Height -->
        <div class="col-lg-4 mb-6 pe-0">
          <div class="form-floating">
            <input formControlName="height" class="form-control" id="inputHeight" type="number" placeholder="2784"
              [min]="0" [max]="300"
              (input)="preventForbiddenCharacters($event, 'number')" />
            <label for="inputHeight">*{{ "height" | translate }}</label>
            <div *ngIf="isControlInvalid('height')" class="text-danger">
              <div *ngIf="formGroup.get('height')?.errors?.['required']">
                {{ "heightIsRequired" | translate }}
              </div>
              <div *ngIf="formGroup.get('height')?.errors?.['max']">
                {{ "maxHeightMustBe300" | translate }}
              </div>
            </div>
          </div>
        </div>
        <!-- Weight -->
        <div class="col-lg-4 px-2">
          <div class="form-floating">
            <input formControlName="weight" class="form-control" id="inputWeight" type="number" placeholder="2784"
              [min]="0" [max]="999"
              (input)="preventForbiddenCharacters($event, 'number')" />
            <label for="inputWeight">*{{ "weight" | translate }}</label>
            <div *ngIf="isControlInvalid('weight')" class="text-danger">
              <div *ngIf="formGroup.get('weight')?.errors?.['required']">
                {{ "weightIsRequired" | translate }}
              </div>
              <div *ngIf="formGroup.get('weight')?.errors?.['max']">
                {{ "maxWeightMustBe1000" | translate }}
              </div>
            </div>
          </div>
        </div>
        <!-- BMI -->
        <div class="col-lg-4 ps-0">
          <div class="form-floating">
            <input formControlName="bmi" class="form-control" id="inputBmi" type="text" placeholder="0" readonly
              [value]="calculateBMI()" />
            <label for="inputBmi">BMI</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contact Information Section -->
  <div class="row g-2">
    <div class="col-md-12">
      <label class="form-label fw-bold fs-14">{{
        "contactInformation" | translate
        }}</label>
    </div>

    <!-- Email -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="email" class="form-control" id="inputEmail" type="email" placeholder="john@amatis.nl"
          (input)="preventForbiddenCharacters($event, 'email')" />
        <label for="inputEmail">*{{ "email" | translate }}</label>
        <div *ngIf="isControlInvalid('email')" class="text-danger">
          <div *ngIf="formGroup.get('email')?.errors?.['required']">
            {{ "emailIsRequired" | translate }}
          </div>
          <div *ngIf="formGroup.get('email')?.errors?.['email']">
            {{ "emailIsInvalid" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Telephone Number -->
    <div class="col-md-4 col-sm-6">
      <app-phone-input formControlName="phone1"></app-phone-input>
      <div *ngIf="isControlInvalid('phone1')" class="text-danger">
        <div *ngIf="formGroup.get('phone1')?.errors?.['required']">
          {{ "telephoneNumberIsRequired" | translate }}
        </div>
        <div *ngIf="formGroup.get('phone1')?.errors?.['minlength']">
          {{ "telNoMinTen" | translate }}
        </div>
        <div *ngIf="formGroup.get('phone1')?.errors?.['pattern']">
          {{ "onlyNumber" | translate }}
        </div>
        <div *ngIf="formGroup.get('phone1')?.errors?.['maxlength']">
          {{ "telNoMinTen" | translate }}
        </div>
      </div>
    </div>
    <!-- Doctor Email -->
    <div class="col-md-4 col-sm-6">
      <div class="form-floating">
        <input formControlName="doctorEmailAddress" class="form-control"
          id="inputdoctorEmailAddress" type="email" placeholder="jane@amatis.nl"
          (input)="preventForbiddenCharacters($event, 'email')" />
        <label for="inputdoctorEmailAddress">*{{ "doctorEmail" | translate }}</label>
        <div *ngIf="isControlInvalid('doctorEmailAddress')" class="text-danger">
          <div *ngIf="formGroup.get('doctorEmailAddress')?.errors?.['required']">
            {{ "doctorEmailIsRequired" | translate }}
          </div>
          <div *ngIf="formGroup.get('doctorEmailAddress')?.errors?.['email']">
            {{ "doctorEmailIsInvalid" | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Doctor Telephone Number -->
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-phone-input formControlName="doctorMobilePhoneNumber">
      </app-phone-input>

      <div *ngIf="isControlInvalid('doctorMobilePhoneNumber')" class="text-danger">
        <div *ngIf="formGroup.get('doctorMobilePhoneNumber')?.errors?.['required']">
          {{ "doctorTelephoneNumberIsRequired" | translate }}
        </div>
        <div *ngIf="formGroup.get('doctorMobilePhoneNumber')?.errors?.['minlength']">
          {{ "telNoMinTen" | translate }}
        </div>
        <div *ngIf="formGroup.get('doctorMobilePhoneNumber')?.errors?.['pattern']">
          {{ "onlyNumber" | translate }}
        </div>
        <div *ngIf="formGroup.get('doctorMobilePhoneNumber')?.errors?.['maxlength']">
          {{ "telNoMinTen" | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Relative Information -->
  <div class="row g-2 mt-4">
    <div class="col-md-12">
      <label class="form-label fw-bold fs-14">{{
        "relativeInformation" | translate
        }}</label>
    </div>
    <div formArrayName="patientRelatives">
      <div *ngFor="let kin of nextOfKins.controls; let i = index" [formGroupName]="i"
        class="row g-2 align-items-start mb-2">

        <!-- Relative Email -->
        <div class="col-md-4 col-sm-6">
          <div class="form-floating">
            <input formControlName="nextOfKinEmailAddress" class="form-control" id="inputnextOfKinEmailAddress{{ i }}"
              type="email" placeholder="jane@amatis.nl" (input)="preventForbiddenCharacters($event, 'email')" />
            <label for="inputnextOfKinEmailAddress{{ i }}"><span *ngIf="i === 0">*</span>{{ "secondaryEmail" | translate
              }}</label>

            <div *ngIf="isControlInvalidAt(i, 'nextOfKinEmailAddress')" class="text-danger">
              <div *ngIf="nextOfKins.at(i).get('nextOfKinEmailAddress')?.errors?.['required']">
                {{ "secondaryEmailIsRequired" | translate }}
              </div>
              <div *ngIf="nextOfKins.at(i).get('nextOfKinEmailAddress')?.errors?.['email']">
                {{ "secondaryEmailIsValid" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Relative Telephone Number -->
        <div class="col-md-4 col-sm-6">
          <app-phone-input formControlName="nextOfKinMobilePhoneNumber"></app-phone-input>
          <div *ngIf="isControlInvalidAt(i, 'nextOfKinMobilePhoneNumber')" class="text-danger">
            <div *ngIf="nextOfKins.at(i).get('nextOfKinMobilePhoneNumber')?.errors?.['required']">
              {{ "telephoneNumberIsRequired" | translate }}
            </div>
            <div *ngIf="nextOfKins.at(i).get('nextOfKinMobilePhoneNumber')?.errors?.['minlength']">
              {{ "telNoMinTen" | translate }}
            </div>
            <div *ngIf="nextOfKins.at(i).get('nextOfKinMobilePhoneNumber')?.errors?.['pattern']">
              {{ "onlyNumber" | translate }}
            </div>
            <div *ngIf="nextOfKins.at(i).get('nextOfKinMobilePhoneNumber')?.errors?.['maxlength']">
              {{ "telNoMinTen" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Notice Preference -->
  <div class="row g-2 mt-4">
    <div class="col-md-12">
      <label class="form-label fw-bold fs-14">{{
        "noticePreferences" | translate
        }}</label>
    </div>

    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered mb-1">
          <thead>
            <tr>
              <th scope="col"></th>
              <th *ngFor="let method of notificationMethods" scope="col" class="text-center">
                {{ method.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let type of notificationTypes">
              <th scope="row">{{ type.label }}</th>
              <td *ngFor="let method of notificationMethods" class="text-center">
                <div class="form-check d-flex justify-content-center">
                  <input class="form-check-input" type="checkbox" [id]="'notification_' + type.id + '_' + method.id"
                    [formControlName]="'notification_' + type.id + '_' + method.id" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-danger">
        <div *ngIf="checkAllNotificationSelectionsAreRequired()">
          {{ "allNotificationSelectionsAreRequired" | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- ECG Upload Section -->
  <div class="mt-5 d-flex align-items-center">
    <button class="btn btn-sm btn-dark" (click)="onDragDropAreaClick()">
      <div *ngIf="isUploading && !uploadedFile; else noFile" class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">{{ "loading" | translate }}</span>
      </div>

      <ng-template #noFile>
        <i class="fa-solid fa-upload me-1 fs-12"></i>
        <span class="fw-bold fs-12">{{ "uploadECG" | translate }}</span>
      </ng-template>
    </button>
    <input type="file" #fileInput class="d-none" (change)="onECGFileSelected($event)" accept=".ecg" />

    <span *ngIf="uploadedFile"><i class="fa-regular fa-file ms-4"></i>
      <span class="ms-2">
        {{ uploadFileName }}
      </span>
    </span>
  </div>

  <!-- Next Step Button -->
  <div class="text-end mt-4">
    <button (click)="goToNextStep()" type="submit" class="btn btn-sm btn-primary cursor-pointer">
      {{ "nextStep" | translate }}
    </button>
  </div>
</form>